import React, { useState, useRef, useEffect } from "react";
import "./SimpleAudioRecorder.css";
import { useAuthErrorHandler } from "../../hooks/useAuthErrorHandler";
import RecorderButton from "./RecorderButton";
import StarToggle from "./StarToggle";
import UploadStatusModal from "./UploadStatusModal";

const SimpleAudioRecorder = ({ onUploadComplete }) => {
  const API_ROUTE = process.env.REACT_APP_API_URL;
  const [isRecording, setIsRecording] = useState(false);
  const [result, setResult] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [isStarred, setIsStarred] = useState(false);
  const isStarredRef = useRef(isStarred);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const handleAuthError = useAuthErrorHandler();

  useEffect(() => { isStarredRef.current = isStarred; }, [isStarred]);
  useEffect(() => {
    if (showResult) {
      const timer = setTimeout(() => setShowResult(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [showResult]);

  const toggleRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);

      mediaRecorder.ondataavailable = (event) => { audioChunksRef.current.push(event.data); };
      mediaRecorder.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });
        const formData = new FormData();
        formData.append("audio_clip", audioBlob, "recording.webm");
        formData.append("is_starred", isStarredRef.current ? "1" : "0");
        try {
          const token = localStorage.getItem("token");
          const response = await fetch(`${API_ROUTE}/audio/upload_audio`, {
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
          });
          if (handleAuthError(response)) return;
          const result = await response.json();
          setResult(result);
          setShowResult(true);
          if (result.status === "Processing" && typeof onUploadComplete === "function") {
            onUploadComplete();
          }
        } catch (error) { console.error("Upload failed:", error); }
        audioChunksRef.current = [];
        setIsStarred(false);
      };

      mediaRecorderRef.current = mediaRecorder;
      mediaRecorder.start();
      setIsRecording(true);
    } catch (err) {
      console.error("Microphone access denied or error:", err);
    }
  };

  const stopRecording = () => {
    mediaRecorderRef.current?.stop();
    setIsRecording(false);
  };

  const showStar = isRecording;

  return (
    <div className="recorder-outer-card">
      <div className="recorder-inner">
        <div className="button-row">
          <RecorderButton
            isRecording={isRecording}
            onClick={() =>
              isRecording
                ? setTimeout(stopRecording, 50)
                : toggleRecording()
            }
          />
          {showStar && (
            <StarToggle
              isStarred={isStarred}
              onToggle={() => setIsStarred(s => !s)}
            />
          )}
        </div>
        {showStar && (
          <div className="star-label-beside">
            {isStarred ? "Starred for manager review" : "Star this for manager review"}
          </div>
        )}
      </div>
      <UploadStatusModal result={result} show={showResult} />
    </div>
  );
};

export default SimpleAudioRecorder;
